import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { fr } from 'date-fns/locale';
import { format } from 'date-fns';
import { IoChevronDown, IoChevronUp } from 'react-icons/io5';
import { LuPaperclip } from 'react-icons/lu';
import styles from './Infos.module.scss';
import { useGetWorksite } from '~/hooks/worksites';
import { INote } from '~/types/clients';
import { downloadFile } from '~/utils';
import { useUserProfile } from '~/hooks/auth';

const Infos = ({ isDesktop = false }: { isDesktop?: boolean }) => {
  const { worksiteId } = useParams();
  const { data: worksite } = useGetWorksite(worksiteId || '');
  const { data: user } = useUserProfile();
  const [noteIsOpen, setNoteIsOpen] = useState(true);
  const [commentsIsOpen, setCommentsIsOpen] = useState(true);
  const token = localStorage.getItem('token');

  const memberPhases = (worksite?.phases || []).filter((phase) => (
    (phase.fitters || []).some((f) => f?.user?._id === user?._id)
  ));
  return (
    <div className={`${styles.infos} ${isDesktop ? styles.desktop : ''}`}>
      {!isDesktop
        && <h1>{worksite?.estimate?.worksite?.name}</h1>
      }
      <div className={styles.field}>
        <label>Contact</label>
        <p>
          {[worksite?.contact?.lastName, worksite?.contact?.firstName].filter(Boolean).join(' ').trim() || '---'}
        </p>
      </div>
      <div className={styles.field}>
        <label>Téléphone</label>
        {worksite?.contact?.phone
          ? <a href={`tel:${worksite?.contact?.phone}`} rel="noreferrer">
          {worksite?.contact?.phone}
        </a>
          : <p>---</p>
        }
      </div>
      {worksite?.estimate?.worksite.address
      && <div className={styles.field}>
        <label>Adresse</label>
        <a target="_blank" href={`https://www.google.com/search?q=${worksite?.estimate?.worksite.address.replace(' ', '+')}+${worksite?.estimate?.worksite.city}`} rel="noreferrer"
          >{worksite?.estimate?.worksite.address}<br/>
            {worksite?.estimate?.worksite.address2
              && <>
                {worksite?.estimate?.worksite.address2}<br/>
              </>
            }
          {worksite?.estimate?.worksite.city}</a>
      </div>
      }
      <div className={styles.field}>
        <label>Date démarrage prévisionnelle</label>
        <p>
          {worksite?.estimatedDates?.startDate ? format(new Date(worksite?.estimatedDates?.startDate), 'dd.MM.yyyy') : '-'}
        </p>
      </div>
      {memberPhases.length > 0 && (
        <div className={styles.field}>
          <label>Mes phases</label>
          {memberPhases.map((phase) => (
            <p key={phase._id}>
              {phase.name || '---'} — {phase.hours || 0}h
            </p>
          ))}
        </div>
      )}
      {worksite?.notes && worksite?.notes?.length > 0 && <div className={styles.panel}>
        <div className={styles?.header}>
          <h2>Notes</h2>
          <button
            type='button'
            className={styles.toggle}
            onClick={() => setNoteIsOpen(!noteIsOpen)}
          >
            {noteIsOpen ? IoChevronUp({}) : IoChevronDown({})}
          </button>
        </div>
        {noteIsOpen && <div className={styles.list}>
          {worksite?.notes.map((n:INote) => <div key={n._id} className={styles.card}>
            <p className={styles.author}>
              {n.author.profile.firstName} {n.author.profile.lastName} | {format(new Date(n.createdAt), 'dd.MM.yyyy', { locale: fr })}
            </p>
            <p className={styles.text}>{n.text}</p>
            {n.file && (
              <div className={styles.file}>
                <a
                  onClick={() => downloadFile(`${process.env.REACT_APP_API_URL}/files/public/${n.file.path}?token=${token}`, n.file.name)}
                  download
                >
                  {LuPaperclip({})}
                  {n.file.name}
                </a>
              </div>
            )}
          </div>)}
        </div>}

      </div>}
      {worksite?.comments && worksite?.comments?.length > 0 && <div className={styles.panel}>
        <div className={styles?.header}>
          <h2>Commentaires</h2>
          <button
            type='button'
            className={styles.toggle}
            onClick={() => setCommentsIsOpen(!commentsIsOpen)}
          >
            {noteIsOpen ? IoChevronUp({}) : IoChevronDown({})}
          </button>
        </div>
        {commentsIsOpen && <div className={styles.list}>
          {worksite?.comments.map((n:INote) => <div key={n._id} className={styles.card}>
            <p className={styles.author}>
              {n.author.profile.firstName} {n.author.profile.lastName} | {format(new Date(n.createdAt), 'dd.MM.yyyy', { locale: fr })}
            </p>
            <p className={styles.text}>{n.text}</p>
            {n.file && (
              <div className={styles.file}>
                <a
                  onClick={() => downloadFile(`${process.env.REACT_APP_API_URL}/files/public/${n.file.path}?token=${token}`, n.file.name)}
                  download
                >
                  {LuPaperclip({})}
                  {n.file.name}
                </a>
              </div>
            )}
          </div>)}
        </div>}

      </div>}
    </div>
  );
};

export default Infos;
